import { Models } from '@rematch/core';
import utilModel from './utilModel';
import documentsModel from './documentsModel';
import notesModel from './notesModel';
import existingCreditModel from './existingCreditModel';
import calculatorModel from './calculatorModel';
import chatsModel from './chatsModel';
import referralsModel from './referralsModel';
import referralReasonsModel from './referralReasonsModel';
import staticDataModel from './staticDataModel';

export interface RootModel extends Models<RootModel> {
  util: typeof utilModel;
  documents: typeof documentsModel;
  notes: typeof notesModel;
  existingCredit: typeof existingCreditModel;
  calculator: typeof calculatorModel;
  chats: typeof chatsModel;
  referrals: typeof referralsModel;
  referralReasons: typeof referralReasonsModel;
  staticData: typeof staticDataModel;
}

export const models: RootModel = {
  util: utilModel,
  documents: documentsModel,
  notes: notesModel,
  existingCredit: existingCreditModel,
  calculator: calculatorModel,
  chats: chatsModel,
  referrals: referralsModel,
  referralReasons: referralReasonsModel,
  staticData: staticDataModel,
};
